import script from "./PreviewCanvas.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewCanvas.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewCanvas.vue?vue&type=style&index=0&id=4e7d4082&lang=scss"

const __exports__ = script;

export default __exports__